import { DirectionsServiceEnum } from "../enums";

export interface IProviderOption {
  value: DirectionsServiceEnum;
  label: string;
}

export const PROVIDER_OPTIONS: IProviderOption[] = [
  { value: DirectionsServiceEnum.Google, label: "Google" },
  { value: DirectionsServiceEnum.OSRM, label: "OSRM" },
  { value: DirectionsServiceEnum.Mapbox, label: "Mapbox" },
  { value: DirectionsServiceEnum.Here, label: "Here" },
  { value: DirectionsServiceEnum.Esri, label: "Esri" },
  { value: DirectionsServiceEnum.TomTom, label: "TomTom" },
];

export const resolveDirectionsServiceLabel = (
  directionsService?: DirectionsServiceEnum,
): string | null => {
  if (!directionsService) {
    return null;
  }

  return (
    PROVIDER_OPTIONS.find(option => option.value === directionsService)
      ?.label ?? directionsService
  );
};

export const PROVIDERS_WITH_AVOID_TOLLS: DirectionsServiceEnum[] = [
  DirectionsServiceEnum.OSRM,
  DirectionsServiceEnum.Google,
  DirectionsServiceEnum.Mapbox,
  DirectionsServiceEnum.Here,
  DirectionsServiceEnum.Esri,
  DirectionsServiceEnum.TomTom,
];
